/* /src/routes/privateRoute.jsx */
import React, { useContext } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { AuthContext } from './authProvider'

export function PrivateRoute() {
  const authContext = useContext(AuthContext)

  return authContext.getAccessToken() ? (
    <Outlet />
  ) : (
    <Navigate to="/signin-oidc/" />
  )
}
